var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "47b3ea1f04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30 58.746094 L 89 58.746094 L 89 135 L 30 135 Z M 30 58.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c778e765fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 308 227 L 347.890625 227 L 347.890625 285 L 308 285 Z M 308 227 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#70b747",
    d: "M 247.753906 236.296875 C 247.492188 237.0625 246.660156 237.472656 245.898438 237.210938 L 112.28125 191.878906 C 111.515625 191.617188 111.113281 190.792969 111.371094 190.027344 L 131.808594 129.859375 C 132.066406 129.09375 132.894531 128.683594 133.660156 128.945312 L 267.273438 174.277344 C 268.035156 174.535156 268.445312 175.363281 268.1875 176.128906 L 247.753906 236.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8dd361",
    d: "M 242.578125 228.652344 C 242.367188 229.277344 241.632812 229.601562 240.949219 229.371094 L 120.984375 188.671875 C 120.300781 188.4375 119.917969 187.738281 120.132812 187.109375 L 136.980469 137.5 C 137.191406 136.878906 137.917969 136.550781 138.609375 136.785156 L 258.574219 177.484375 C 259.257812 177.722656 259.640625 178.421875 259.425781 179.050781 L 242.578125 228.652344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#70b747",
    d: "M 207.132812 188.964844 C 203.878906 198.542969 193.472656 203.679688 183.886719 200.425781 C 174.304688 197.171875 169.167969 186.769531 172.421875 177.191406 C 175.679688 167.613281 186.085938 162.480469 195.667969 165.730469 C 205.253906 168.984375 210.390625 179.386719 207.132812 188.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#70b747",
    d: "M 136.980469 137.5 L 132.410156 150.949219 C 140.46875 153.683594 149.21875 149.371094 151.960938 141.316406 L 138.609375 136.785156 C 137.917969 136.550781 137.191406 136.878906 136.980469 137.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#70b747",
    d: "M 120.886719 188.632812 L 134.335938 193.199219 C 137.070312 185.144531 132.757812 176.398438 124.699219 173.664062 L 120.164062 187.007812 C 119.933594 187.691406 120.257812 188.417969 120.886719 188.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#70b747",
    d: "M 259.425781 179.050781 L 254.859375 192.488281 C 246.800781 189.757812 242.484375 181.011719 245.21875 172.960938 L 258.574219 177.484375 C 259.257812 177.722656 259.640625 178.421875 259.425781 179.050781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#70b747",
    d: "M 241.050781 229.40625 L 227.597656 224.839844 C 230.335938 216.789062 239.082031 212.472656 247.140625 215.207031 L 242.613281 228.550781 C 242.382812 229.234375 241.679688 229.617188 241.050781 229.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9aa6c",
    d: "M 196.671875 138.554688 C 196.671875 138.554688 171.867188 100.417969 161.878906 94.980469 C 161.878906 94.980469 146.03125 84.265625 81.625 74.835938 L 70.429688 107.804688 C 70.429688 107.804688 106.109375 143.261719 109.070312 146.253906 C 112.03125 149.25 123.902344 156.75 130.589844 159.019531 C 137.273438 161.289062 163.257812 174.082031 163.257812 174.082031 C 163.25 174.082031 169.273438 176.121094 172.722656 171.214844 C 174.773438 168.296875 174.949219 166.371094 173.371094 164.167969 C 173.371094 164.167969 171.59375 160.140625 146.757812 142.148438 C 139.042969 136.554688 131.667969 121.378906 135.125 119.320312 C 140.957031 115.835938 148.160156 117.535156 148.160156 117.535156 L 164.398438 128.257812 L 178.472656 144.148438 L 201.894531 152.097656 C 201.894531 152.097656 201.457031 145.300781 196.671875 138.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8bd90",
    d: "M 164.066406 158.519531 L 157.429688 167.632812 C 157.429688 167.632812 164.925781 173.371094 168.691406 170.148438 C 173.425781 166.105469 168.792969 161.617188 164.066406 158.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#99def2",
    d: "M 67.332031 125.699219 L 82.046875 130.691406 L 100.828125 75.386719 L 86.117188 70.394531 L 67.332031 125.699219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47b3ea1f04)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#354d7f",
    d: "M 66.675781 134.960938 L 30.121094 122.554688 L 51.792969 58.75 L 88.347656 71.148438 L 66.675781 134.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9aa6c",
    d: "M 171.050781 291.871094 C 161.394531 290.988281 105.199219 257.640625 105.199219 257.640625 C 105.199219 257.640625 102.5625 247.988281 116.613281 247.988281 C 130.660156 247.988281 168.417969 260.277344 168.417969 260.277344 L 193.171875 257.820312 C 193.171875 257.820312 185.511719 250.210938 195.539062 245.417969 C 203.78125 241.46875 240.242188 226.230469 249.027344 223.59375 C 257.804688 220.964844 290.296875 227.984375 300.832031 234.121094 L 300.832031 273.617188 C 300.832031 273.617188 180.710938 292.75 171.050781 291.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8bd90",
    d: "M 206.292969 245.242188 C 206.292969 245.242188 208.046875 255.214844 208.046875 257.554688 C 208.046875 257.554688 195.160156 260.746094 195.171875 251.382812 C 195.175781 245.40625 206.292969 245.242188 206.292969 245.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e89258",
    d: "M 193.171875 257.820312 C 193.171875 257.820312 198.558594 262.210938 211.5 259.578125 C 211.5 259.578125 234.101562 253.105469 236.730469 251.660156 C 236.730469 251.660156 256.050781 247.253906 266.882812 251.660156 C 266.882812 251.660156 211.074219 273.910156 193.171875 257.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8bd90",
    d: "M 123.058594 267.996094 L 125.6875 261.730469 C 125.6875 261.730469 111.945312 248.863281 106.054688 258.148438 C 108.316406 259.484375 114.882812 263.34375 123.058594 267.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#99def2",
    d: "M 313.417969 279.761719 L 296.148438 279.761719 L 296.148438 227.6875 L 313.417969 227.6875 L 313.417969 279.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c778e765fd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#354d7f",
    d: "M 347.664062 284.734375 L 308.734375 284.734375 L 308.734375 227.6875 L 347.664062 227.6875 L 347.664062 284.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.89f2b224df38a37164172cf2ae683242.svg";
export { ForwardRef as ReactComponent };